<!-- Date Selection Section -->
<div class="mb-4" [formGroup]="formGroup()">
  <!-- Date Pickers -->
  @if (showDatePickers) {
    <h5 class="text-base font-semibold text-900 mb-3">Date Selection</h5>
    <div class="grid">
      <div class="col-12 md:col-6">
        <label
          class="block text-sm text-700 mb-2 font-semibold"
          data-testid="start-date-label"
        >
          {{ 'FREEZE.FREEZE_SIDEBAR.LABEL_STARTDATE' | translate }}
        </label>
        <p-datepicker
          [showIcon]="true"
          styleClass="w-full"
          placeholder="{{ 'FREEZE.FREEZE_SIDEBAR.PLACEHOLDER_SELECTDATE' | translate }}"
          formControlName="startdate"
          inputStyleClass="text-sm"
          inputId="startDate"
          [readonlyInput]="true"
          aria-label="start-date-calendar"
          data-testid="start-date-calendar"
          [minDate]="canByPassMinStartDate ? null : minStartDate"
        />
        @if (startDateControl?.touched && startDateControl?.invalid) {
          <app-error-msg
            [errors]="startDateControl?.errors"
            [fieldLabel]="'FREEZE.FREEZE_SIDEBAR.STARTDATE' | translate"
            data-testid="start-date-error"
          />
        }
      </div>
      <div class="col-12 md:col-6">
        <label
          class="block text-sm text-700 mb-2 font-semibold"
          data-testid="end-date-label"
        >
          {{ 'FREEZE.FREEZE_SIDEBAR.LABEL_ENDDATE' | translate }}
        </label>
        <p-datepicker
          [showIcon]="true"
          styleClass="w-full"
          placeholder="{{ 'FREEZE.FREEZE_SIDEBAR.PLACEHOLDER_SELECTDATE' | translate }}"
          formControlName="enddate"
          inputStyleClass="text-sm"
          inputId="endDate"
          [readonlyInput]="true"
          aria-label="end-date-calendar"
          data-testid="end-date-calendar"
          [minDate]="minEndDate"
        />
        @if (endDateControl?.touched && endDateControl?.invalid) {
          <app-error-msg
            [errors]="endDateControl?.errors"
            [fieldLabel]="'FREEZE.FREEZE_SIDEBAR.ENDDATE' | translate"
            data-testid="end-date-error"
          />
        }
      </div>
    </div>
    <div class="mt-3">
      <p-message
        severity="info"
        styleClass="w-full"
        aria-label="freeze-days-message"
        data-testid="freeze-days-message"
      >
        {{ 'FREEZE.FREEZE_DAYS' | translate: { count: calculateDays() } }}
      </p-message>
    </div>
  }

  <!-- Billing Cycle Multiselect -->
  @if (showMultiselect) {
    <h5 class="text-base font-semibold text-900 mb-3">Billing Cycle Selection</h5>
    <label
      class="block text-sm text-700 mb-2 font-semibold"
      data-testid="freeze-cycle-label"
    >
      {{ 'FREEZE.FREEZE_SIDEBAR.FREEZE_BILLING_CYCLE' | translate }}
    </label>
    <p-multiSelect
      [options]="filteredTimeline()"
      formControlName="selectedfreezeattempt"
      optionLabel="formated_date"
      display="chip"
      optionDisabled="is_frozen"
      styleClass="w-full"
      [selectionLimit]="selectionLimit()"
      placeholder="{{ 'FREEZE.FREEZE_SIDEBAR.PLACEHOLDER_SELECTCYCLE' | translate }}"
      aria-label="freeze-cycle-multiselect"
      data-testid="freeze-cycle-multiselect"
    >
      <ng-template pTemplate="selectedItem">
        @if (selectedFreezeAttemptControl?.value) {
          <div
            class="text-sm"
            [innerHTML]="selectedFreezeAttemptControl?.value?.formated_start_date"
          ></div>
        }
      </ng-template>
      <ng-template let-freezeAttempt pTemplate="item">
        <div class="text-sm" [innerHTML]="freezeAttempt.formated_start_date"></div>
      </ng-template>
    </p-multiSelect>
    @if (selectedFreezeAttemptControl?.touched && selectedFreezeAttemptControl?.invalid) {
      <app-error-msg
        [errors]="selectedFreezeAttemptControl?.errors"
        [fieldLabel]="'FREEZE.FREEZE_SIDEBAR.ENDDATE' | translate"
        data-testid="freeze-cycle-error"
      />
    }
  }
</div>
